import React from 'react';
import LightTemplate from './LightTemplate';
import {DarkTemplate} from './DarkTemplate';
import {getSiteUrls} from '../../helpers/url.helper';

export const ThemeAllocator = (template, restaurant, config, navUrls, serverOffline, location) => {
  let urls = navUrls;
  if (!urls) {
    urls = getSiteUrls();
  }
  switch (template) {
    case 'light': {
      return (
        <LightTemplate
          restaurant={restaurant}
          config={config}
          navUrls={urls}
          serverOffline={serverOffline}
          location={location}
        />
      );
    }
    default:
      return DarkTemplate(restaurant, config, urls);
  }
};



// WEBPACK FOOTER //
// ./components/ThemeAllocator/ThemeAllocator.js